import { BotoesNavegacao } from '@/global/components/BotoesNavegacao'
import { useStore } from '@/store'
import { useEffect, useState } from 'react'
import { useEscopoContext } from './context'
import { um } from './escopo'
import {
    calcularLimitesNavegacao,
    carregarAtePosicionar,
    encontrarVizinho,
    type PassoNavegacao,
} from './navegacao'
import type { Opcao } from './useFacetaOptions'

/**
 * Setas para percorrer os funcionários do escopo sem abrir o painel — o Espelho
 * do ponto é folheado funcionário a funcionário. Quando chega no fim das
 * páginas carregadas, puxa a próxima e segue no primeiro dela.
 *
 * Só faz sentido com a faceta de funcionário em seleção única.
 */
export function NavegarFuncionario({
    className,
    followStore = true,
}: {
    className?: string
    /** Segue o funcionarioId do store */
    followStore?: boolean
}) {
    const { valor, setFaceta, dados } = useEscopoContext()
    const [navegando, setNavegando] = useState(false)
    const funcionarioId = useStore(state => state.employeeId)

    const opcoes = dados.funcionarios.opcoes
    const atual = um(valor.funcionarios)
    const carregarMais = dados.funcionarios.carregarMais

    const { isPrimeiro, isUltimo } = calcularLimitesNavegacao({
        opcoes,
        atualId: atual,
        temMais: dados.funcionarios.temMais,
    })

    useEffect(() => {
        if (!followStore) return
        if (funcionarioId > 0) setFaceta('funcionarios', funcionarioId)
    }, [funcionarioId, followStore])

    async function primeiroDaProximaPagina(
        lista: Opcao[],
    ): Promise<Opcao | null> {
        if (!carregarMais) return null

        const novos = await carregarMais()
        const inedito = novos.find(
            novo => !lista.some(opcao => opcao.id === novo.id),
        )
        return inedito ?? null
    }

    async function navegar(passo: PassoNavegacao) {
        setNavegando(true)
        try {
            const lista = await carregarAtePosicionar(
                opcoes,
                atual,
                carregarMais,
            )
            const vizinho =
                encontrarVizinho(lista, atual, passo) ??
                (passo === 1 ? await primeiroDaProximaPagina(lista) : null)

            if (vizinho) setFaceta('funcionarios', vizinho.id)
        } finally {
            setNavegando(false)
        }
    }

    return (
        <BotoesNavegacao
            onAnterior={() => navegar(-1)}
            onProximo={() => navegar(+1)}
            rotuloAnterior="Funcionário anterior"
            rotuloProximo="Próximo funcionário"
            isAnteriorDesabilitado={isPrimeiro || navegando}
            isProximoDesabilitado={isUltimo || navegando}
            className={className}
        />
    )
}
